<div class="card col-12 {{(inFuture) ? 'future-event' : 'past-event'}}">
  <div class="card-icon text-center"><span class="fas fa-{{(event.icon) ? event.icon : 'calendar-day'}}"></span></div>
  <div class="card-body">
    <h4 class="card-title h5">{{event.name}}</h4>
    <span>{{event.time}} - {{event.date}}</span>
    <hr />
    <p class="card-text">{{event.description}}</p>
    <dl class="row">
      <ng-container *ngIf="event.location">
        <dt class="col-sm-4">Location</dt>
        <dd class="col-sm-8">{{event.location}}</dd>
      </ng-container>
      <ng-container *ngIf="event.price">
        <dt class="col-sm-4">Price</dt>
        <dd class="col-sm-8">{{event.price}}</dd>
      </ng-container>
      <ng-container *ngIf="event.contact">
        <dt class="col-sm-4">Contact</dt>
        <dd class="col-sm-8">{{event.contact}}</dd>
      </ng-container>
    </dl>
  </div>
</div>
